import http from "./Base-service";
class DashboardService {

    getAllCameras() {
        return http.get('listCameras');
    }

}
export default new DashboardService();